import SectionCard, {
  SectionCardGroup
} from "@/appComponents/Blocks/Composites/SectionCard/SectionCard";
import UpgradeCard from "@/appComponents/Blocks/Composites/UpgradePopover/UpgradeCard";
import { UpgradeInfoCard } from "@/appComponents/Blocks/Composites/UpgradePopover/UpgradeInfoCard";
import { enumFeaturesList } from "@coreapp/constants";
import { appstr } from "@coreapp/utils/appstr";
import { DynamicTextProps } from "@theorgchartdev/storybook/dist/components/Text/DynamicText";

const UpgradeApprovals = () => {
  const upgradeApprovalsDynamicText: DynamicTextProps = {
    template: appstr("plan approvals upgrade template"),
    formatConfig: {
      bold1: { type: "bold" }
    },
    replaceDict: {
      bold1: appstr("plan approval system")
    }
  };

  return (
    <SectionCardGroup>
      <SectionCard
        title={appstr("Enable approvals")}
        customCardStyle={{ background: "var(--bg-brand-secondary)" }}
      >
        <div className="ocn-upgrade-card-text">
          <UpgradeCard iconName={"marker-regular-full"} featureKey={enumFeaturesList.planApprovals}>
            <UpgradeInfoCard.Body dynamic={upgradeApprovalsDynamicText}>
              {appstr("plan approvals upgrade message")}
            </UpgradeInfoCard.Body>
          </UpgradeCard>
        </div>
      </SectionCard>
    </SectionCardGroup>
  );
};

export default UpgradeApprovals;
